(() => {
  if (customElements.get('facts-dosing-method')) return;
  class FactsDosingMethod extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.steps = [...this.querySelectorAll('.step')];
      this.pauseButton = this.querySelector('[data-pause-toggle]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (button?.matches('[data-replay]')) {
          this.pause(false);
          this.steps.forEach(step => { step.style.removeProperty('--delay'); this.play(step); });
        } else if (button?.matches('[data-replay-step]')) {
          this.pause(false);
          const step = button.closest('.step');
          step.style.setProperty('--delay', '0s');
          this.play(step);
        } else if (button?.matches('[data-pause-toggle]')) {
          this.pause(!this.classList.contains('is-paused'));
        }
        if (event.target.closest('[data-source]')) {
          const notes = this.querySelector('details');
          if (notes) notes.open = true;
        }
      }, { signal: this.controller.signal });
      this.reduced.addEventListener('change', () => this.setup(), { signal: this.controller.signal });
      this.setup();
    }
    setup() {
      this.observer?.disconnect();
      this.removeAttribute('data-ready');
      this.steps.forEach(step => step.classList.remove('playing'));
      this.pause(false);
      if (this.dataset.animate !== 'true' || this.reduced.matches) return;
      // Keep the finished graphic visible in the editor and when autoplay is off.
      if (window.Shopify?.designMode || this.dataset.autoplay !== 'true') return;
      if (!('IntersectionObserver' in window) || !CSS.supports('offset-path', 'path("M0 0 L1 1")')) return;
      this.setAttribute('data-ready', '');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { this.play(entry.target); this.observer.unobserve(entry.target); }
        });
      }, { threshold: .22 });
      this.steps.forEach(step => this.observer.observe(step));
    }
    play(step) {
      if (this.reduced.matches || this.dataset.animate !== 'true') return;
      step.classList.remove('playing');
      void step.offsetWidth;
      step.classList.add('playing');
      this.observer?.unobserve(step);
    }
    pause(value) {
      this.classList.toggle('is-paused', value);
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-pressed', String(value));
      this.pauseButton.querySelector('span').textContent = value ? this.dataset.resume : this.dataset.pause;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('facts-dosing-method', FactsDosingMethod);
})();
